import { PrixContextDebugMap } from '../../../Helpers/QuotationHelper';
import { QuestionItem } from '../../../Models/Questions/QuestionDto';
import { QuotationReplyBaseDto } from '../../../Models/Quotations/Quotations';
import { StoreDto } from '../../../Models/TravelExpenses/StoreDto';
import { VersionParametrageDto } from '../../../Models/VersionParametrages/VersionParametrage';
import { ContextQuestionList } from '../../../Plugins/FloorPlan/Models/IMapItem';

export enum LoadingStep {
    Auth = 'LoadingAuth',
    Version = 'LoadingVersion',
    Configuration = 'LoadingConfiguration',
    Map = 'LoadingMap',
    InitConfiguration = 'InitConfiguration',
}

export type QuoteState = Partial<{
    loadingStep: LoadingStep;
    versionId: string;

    versionData: VersionParametrageDto;

    questions: Array<QuestionItem>; //!\ questions filtred by seller
    produitRef: string; //!\ use only when produit question from ref

    stepHabitation: ContextQuestionList;
    habitationQuestionsOpen: boolean; //* DIALOG

    stepServices: ContextQuestionList;
    stepSynthese: ContextQuestionList;

    projetStoreLead: StoreDto;
    projetStoreDelivery: StoreDto;

    loadingQuotation: boolean;
    quote: QuotationReplyBaseDto;
    quotePrixContextDebugMap: PrixContextDebugMap;
}>
